/** Passive transport contract: safe to import without constructing a simulation. */
export const CLIMATE_RENDER_STRIDE = 28;
export const ClimateField = {
  atmosphere: 0, sea: 1, clouds: 2, ice: 3,
  albedo: 4, temperature: 5, pressure: 6, envelope: 7,
  groundColour: 8, atmosphereColour: 12, liquidColour: 16,
  plasma: 19, iceColour: 20, cloudColour: 24,
} as const;

export interface ClimateTelemetry {
  readonly index: number;
  readonly name: string;
  readonly temperature: number;
  readonly albedo: number;
  readonly pressure: number;
  readonly cloudCover: number;
  readonly seaLevel: number;
  readonly liquidCoverage: number;
  readonly seaLevelMeters: number;
  readonly liquidVolumeM3: number;
  readonly atmosphericMassKg: number;
  readonly hasSurface: boolean;
  readonly layerTemperatures: { readonly atmosphere: number | null; readonly surface: number | null; readonly crust: number | null };
  readonly dominantLiquid: string | null;
  readonly materials: readonly {
    readonly name: string;
    /** Solid, liquid, gas, plasma amounts (not fractions). */
    readonly phases: readonly [number, number, number, number];
  }[];
  readonly phases: readonly number[];
  readonly fusion: boolean;
}
